<template>
    <div>
        <div class="data-form">
            <ValidationObserver ref="importForm">
                <div class="row">
                    <div class="col-12">
                        <ValidationProvider name="file" rules="required" v-slot="{errors}">
                            <b-form-group :label="$t('excel_file')">
                                <div class="d-flex custom-file-upload">
                                    <b-form-file
                                        accept=".xlsx,.xls"
                                        v-model="defineForm.file"
                                        :state="errors[0] ? false : null"
                                        :placeholder="$t('select_file')"
                                        :drop-placeholder="$t('drop_file')"
                                        ref="fileInput"
                                        multiple></b-form-file>
                                    <b-button variant="outline-secondary" @click="$refs.fileInput.$el.childNodes[0].click();">{{ $t('browse') }}</b-button>
                                </div>
                                <div class="invalid-feedback d-block" v-if="errors[0]" v-html="errors[0]"></div>
<!--                                <div class="alert alert-info mt-2">{{ $t('course_import_text') }}</div>-->
<!--                                <DownloadExcelTemplate :code="'reservation_excel_import'" class="mt-2"/>-->
                            </b-form-group>
                        </ValidationProvider>
                    </div>
                    <div class="col-12 bordered mb-3">
                        <b-table
                            :empty-text="this.$t('no_result')"
                            bordered
                            striped
                            responsive
                            :items="skippedItems"
                            :fields="skippedFields"
                            class="mb-0 table-dropdown no-scrollbar border rounded"
                        >
                            <template #custom-foot="data">
                                <b-tr>
                                    <b-td colspan="2">
                                        <strong>{{ $t('total') }}: {{ skipped_data_count }}</strong>
                                    </b-td>
                                    <b-td colspan="2">
                                        <strong>{{ $t('number_of_records_updated') }}: {{updated_data_count}}</strong>
                                    </b-td>

                                </b-tr>
                            </template>

                        </b-table>
                    </div>
                    <div class="col-12 d-flex justify-content-center">
                        <processing-button :processing="processing"
                                           :label="$t('import')"
                                           variant="primary"
                                           @click="sendForm"/>
                    </div>
                </div>
            </ValidationObserver>
        </div>
    </div>
</template>
<script>
import ProcessingButton from "@/components/elements/ProcessingButton.vue";
import {ValidationObserver, ValidationProvider} from "vee-validate";
import SchoolService from "@/services/SchoolService";

export default {
    components: {
        ProcessingButton,
        ValidationObserver,
        ValidationProvider,
    },

    data() {
        return {
            defineForm: {
                file: null
            },
            updated_data_count:0,
            skipped_data_count:0,
            skippedItems:[],
            skippedFields:[
                {
                    key: 'excel_line_number',
                    label: this.$t('line')
                },
                {
                    key: 'name',
                    label: this.$t('name')
                },
                {
                    key: 'code',
                    label: this.$t('code')
                },

                {
                    key: 'message',
                    label: this.$t('message')
                },

            ],
            processing: false
        }
    },
    methods: {
        async sendForm() {
            const isValid = await this.$refs.importForm.validate();
            if (isValid) {
                this.processing = true
                let formData = new FormData();
                formData.append('file', this.defineForm.file[0])
                SchoolService.importExcel(formData)
                    .then(response => {
                        this.$toast.success(this.$t('api.' + response.data.message))
                         const skippedData = response.data?.data.skipped_data;
                          this.skipped_data_count=response.data?.data.skipped_data_count
                          this.updated_data_count=response.data?.data.updated_data_count
                            this.skippedItems.push(
                                ...skippedData,
                            )
                        this.$emit('successProcess')
                    })
                    .catch(e => {
                        this.showErrors(e, this.$refs.importForm)
                    })
                    .finally(() => {
                        this.processing = false
                    })

            }
        },
    }
}
</script>
